
import { h } from 'preact'
import SimpleCollapsible from '../../ui-components/SimpleCollapsible'
import InputGroup from '../../ui-components/InputGroup'
import DropdownControl from '../../dropdown/DropdownControl'
import ButtonControl from '../../button-control'
import Switcher from '../../control/Switcher'

export type MetaRobotsType = 'index, follow' | 'noindex, follow' | 'index, nofollow' | 'noindex, nofollow'
const META_ROBOTS: Array<MetaRobotsType> = ['index, follow', 'noindex, follow', 'index, nofollow', 'noindex, nofollow']

interface Props {
  seoTitle: string,
  seoDescription: string,
  onChangeTitle: (value: string) => void,
  onChangeDescription: (value: string) => void,
  hideFromSearch?: boolean,
  displayRobotsSettings: boolean,
  metaRobots?: MetaRobotsType,
  onChangeMetaRobot?: (value: string) => void,
  onChangeHideFromSearch?: (value: boolean) => void
}

const normalizeMetaRobots = (onChangeMetaRobot: undefined | Props['onChangeMetaRobot'], metaRobots: MetaRobotsType | undefined) => {
  return META_ROBOTS.filter(meta_robot => meta_robot !== metaRobots).map((meta_robot) => ({
    title: meta_robot,
    onClick: () => onChangeMetaRobot?.(meta_robot)
  }))
}

const SeoSettings = ({seoTitle, seoDescription, displayRobotsSettings, metaRobots, hideFromSearch, onChangeMetaRobot, onChangeTitle, onChangeDescription, onChangeHideFromSearch}: Props) => {
  return (
    <SimpleCollapsible title='SEO settings'>
      <InputGroup
        title='SEO Title'
        placeholder='Add a title'
        type={'text'}
        onChange={(e) => onChangeTitle(e.target.value)}
        value={seoTitle} />
      <InputGroup
        title='SEO Description'
        placeholder='Add a description'
        type={'text'}
        onChange={(e) => onChangeDescription(e.target.value)}
        value={seoDescription} />
      {
        displayRobotsSettings && onChangeMetaRobot && (
          <div className='form-group'>
            <label>Meta Robots</label>
            <DropdownControl
              align='adjust'
              triggerClass='seo_meta-robots'
              trigger={<ButtonControl class='seo_meta-robots-trigger' title={metaRobots} icon={'arrowDropdown'} />}
              items={normalizeMetaRobots(onChangeMetaRobot, metaRobots)}
            />
          </div>
        )
      }
      {
        displayRobotsSettings && onChangeHideFromSearch && (
          <div className='category--hide-search form-group'>
            <Switcher
              on={hideFromSearch}
              label='Hide category and topics from platform search'
              onChange={() => onChangeHideFromSearch(!hideFromSearch)} />
          </div>
        )
      }
    </SimpleCollapsible>
  )
}

export default SeoSettings
